import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { editUserDetails } from '../redux/actions/userActions';



const styles = {
  form: {
    textAlign: "left",
  },
  container: {
    padding: "2em",
  },
  pageTitle: {
    margin: "10px auto 10px auto",
    fontFamily: "'Avenir', 'Helvetica', 'Arial', sans-serif;",
    fontSize: "2em",
    textAlign: "left",
  },
  textField: {
    margin: "10px auto 10px auto",
  },
  button: {
    marginTop: "2em",
    position: "relative",
    width: "100%",
  },
  customError: {
    color: "red",
    fontSize: "0.8rem",
  },
  progress: {
    position: "absolute",
  },
};

class editProfile extends Component {

  state = {
    name: '',
    school: '',
    year: '',
    goal: '',
    facebook: '',
    linkedin: '',
    open: false
  };

  mapUserDetailsToState = (user) => {
    this.setState({
      name: user.name ? user.name : '',
      school: user.school ? user.school : '',
      year: user.year ? user.year : '',
      goal: user.goal ? user.goal : '',
      facebook: user.facebook ? user.facebook : '',
      linkedin: user.linkedin ? user.linkedin : '',
    });
  };

  handleOpen = () => {
    this.setState({ open: true });
    this.mapUserDetailsToState(this.props.data);
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.history.push('/profile');
  };

  componentDidMount() {
    const user = this.props.user;
    this.mapUserDetailsToState(user);
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  handleSubmit = () => {
    const userDetails = {
      name: this.state.name,
      school: this.state.school,
      year: this.state.year,
      goal: this.state.goal,
      facebook: this.state.facebook,
      linkedin: this.state.linkedin
    };
    this.props.editUserDetails(userDetails);
    this.handleClose();
  };

  render() {
    const { classes } = this.props;
    const { errors, loading } = this.state;

    const MyLink = props => <Link to="/profile" {...props} />

    return (
      <Grid container className={classes.form}>
        <Grid item sm />
        <Grid item sm className={classes.container}>
          <Typography variant="h3" className={classes.pageTitle}>
            Update Your Profile
          </Typography>
          <br />
          <form noValidate onSubmit={this.handleSubmit}>
            <TextField
              id="name"
              name="name"
              type="text"
              label="Name"
              className={classes.textField}
              value={this.state.name}
              onChange={this.handleChange}
              fullWidth
            />
            <TextField
              id="school"
              name="school"
              type="text"
              label="School"
              className={classes.textField}
              value={this.state.school}
              onChange={this.handleChange}
              fullWidth
            />
            <TextField
              id="year"
              name="year"
              type="text"
              label="Year"
              className={classes.textField}
              value={this.state.year}
              onChange={this.handleChange}
              fullWidth
            />
            <TextField
              id="goal"
              name="goal"
              type="text"
              label="Career Goals"
              className={classes.textField}
              value={this.state.goal}
              onChange={this.handleChange}
              fullWidth
            />
            <TextField
              id="facebook"
              name="facebook"
              type="text"
              label="Facebook Page"
              className={classes.textField}
              value={this.state.facebook}
              onChange={this.handleChange}
              fullWidth
            />
            <TextField
              id="linkedin"
              name="linkedin"
              type="text"
              label="LinkedIn Page"
              className={classes.textField}
              value={this.state.linkedin}
              onChange={this.handleChange}
              fullWidth
            />

            <Button
              type="submit"
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={this.handleSubmit} 
              disabled={loading}
            >
              Save Profile
              {loading && (
                <CircularProgress size={30} className={classes.progress} />
              )}
            </Button>

            <Button
              type="submit"
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={this.handleClose} 
              disabled={loading}
            >
              Cancel
              {loading && (
                <CircularProgress size={30} className={classes.progress} />
              )}
            </Button>
            <br />
          </form>
        </Grid>
        <Grid item sm />
      </Grid>
    );
  }
}

editProfile.propTypes = {
  editUserDetails: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  user: state.user
});

export default connect( mapStateToProps, { editUserDetails })(withStyles(styles)(editProfile));
